import type { Locale } from '../locale';

export const snapshotAgentInstruction = (command: string) =>
  `Use your usual ${command} check once. Reuse that output until the files or Git state change. If it leaves a question open, inspect only what you need to answer it.`;

const en = {
  title: 'Try one Git inspection',
  observed: (command: string, count: string) => `Your agent repeated the same ${command} check ${count} times with no workspace change recorded between checks.`,
  instruction: (command: string) => `Add this to your usual brief: “${snapshotAgentInstruction(command)}”`,
  noOpportunity: 'Your baseline showed no repeated Git inspection that this lesson can address. You can keep your workflow and continue.',
  unavailable: 'There is no usable Git activity record for this baseline. You can keep your result and continue.',
  continue: 'Keep my baseline and continue',
  cheaper: 'Both runs passed with the same model. On another task, reuse Git output while the state stays the same.',
  course: 'Practice this in the full course',
};

export const snapshotCoachingCopy: Record<Locale, typeof en> = {
  en,
  ar: {
    title: 'جرّب فحص Git مرة واحدة',
    observed: (command, count) => `كرّر وكيلك فحص ${command} نفسه ${count} مرة دون تسجيل أي تغيير في مساحة العمل بين الفحوص.`,
    instruction: (command) => `أضف إلى تكليفك المعتاد: «نفّذ فحص ${command} المعتاد مرة واحدة. أعد استخدام المخرجات إلى أن تتغير الملفات أو حالة Git. إذا بقي سؤال، فافحص القدر اللازم للإجابة عنه.»`,
    noOpportunity: 'لم تُظهر محاولتك الأساسية فحصًا متكررًا لـ Git يمكن لهذا الدرس معالجته. يمكنك المتابعة بطريقتك الحالية.',
    unavailable: 'لا يتوفر سجل نشاط Git يمكن استخدامه لهذه المحاولة. يمكنك الاحتفاظ بنتيجتك والمتابعة.',
    continue: 'احتفظ بمحاولتي الأساسية وتابع',
    cheaper: 'نجحت المحاولتان بالنموذج نفسه. في مهمة أخرى، أعد استخدام مخرجات Git طالما بقيت الحالة كما هي.',
    course: 'تدرّب على ذلك في الدورة الكاملة',
  },
  de: {
    title: 'Git einmal prüfen',
    observed: (command, count) => `Dein Agent hat dieselbe Prüfung mit ${command} ${count}-mal durchgeführt. Dazwischen wurde keine Änderung im Arbeitsbereich aufgezeichnet.`,
    instruction: (command) => `Ergänze deinen üblichen Auftrag: „Führe deine übliche Prüfung mit ${command} einmal aus. Nutze die Ausgabe weiter, bis sich Dateien oder der Git-Zustand ändern. Prüfe bei offenen Fragen nur das, was du zur Antwort brauchst.“`,
    noOpportunity: 'Dein Ausgangslauf zeigte keine wiederholte Git-Prüfung, bei der diese Lektion helfen kann. Du kannst mit deiner bisherigen Arbeitsweise fortfahren.',
    unavailable: 'Für diesen Ausgangslauf liegt kein nutzbares Git-Aktivitätsprotokoll vor. Du kannst dein Ergebnis behalten und fortfahren.',
    continue: 'Ausgangslauf behalten und fortfahren',
    cheaper: 'Beide Läufe haben mit demselben Modell bestanden. Nutze bei einer anderen Aufgabe dieselbe Git-Ausgabe weiter, solange der Zustand gleich bleibt.',
    course: 'Im vollständigen Kurs weiterüben',
  },
  ja: {
    title: 'Git の確認を一度に絞る',
    observed: (command, count) => `エージェントは ${command} による同じ確認を ${count} 回行いました。その間に作業環境の変更は記録されていません。`,
    instruction: (command) => `普段の依頼に次を加えてください。「いつもの ${command} による確認を一度だけ行う。ファイルや Git の状態が変わるまでは、その出力を再利用する。疑問が残ったら、答えに必要な範囲だけ確認する。」`,
    noOpportunity: '基準実行には、このレッスンで改善できる Git の繰り返し確認がありませんでした。今の手順のまま進めます。',
    unavailable: 'この基準実行には利用できる Git の活動記録がありません。結果を保持したまま続けられます。',
    continue: '基準実行を保存したまま進む',
    cheaper: 'どちらの実行も同じモデルで合格しました。別の課題でも、状態が変わるまでは Git の出力を再利用してください。',
    course: '全コースでこの手順を練習する',
  },
};
